import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import ResponsiveContainer from './ResponsiveContainer';

const PREDEFINED_GOALS = [
  'Weight Loss',
  'Build Muscle',
  'Move without pain',
  'Performance/productivity',
  'Improve Fitness & Energy'
];

function GoalSelectionPage({ personalDetails, setPersonalDetails, t }) {
  const navigate = useNavigate();
  const existingGoals = personalDetails.goals || [];
  const existingCustom = personalDetails.customGoal || '';

  const [selectedGoals, setSelectedGoals] = useState(
    existingGoals.filter((g) => PREDEFINED_GOALS.includes(g))
  );
  const [customSelected, setCustomSelected] = useState(
    existingGoals.some((g) => !PREDEFINED_GOALS.includes(g)) || !!existingCustom
  );
  const [customGoal, setCustomGoal] = useState(
    existingCustom || existingGoals.find((g) => !PREDEFINED_GOALS.includes(g)) || ''
  );
  const [isSubmitting, setIsSubmitting] = useState(false);

  const toggleGoal = (goal) => {
    setSelectedGoals((prev) =>
      prev.includes(goal) ? prev.filter((g) => g !== goal) : [...prev, goal]
    );
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const goals = [...selectedGoals];
    if (customSelected && customGoal.trim()) {
      goals.push(customGoal.trim());
    }

    if (goals.length === 0) {
      alert(t('pleaseSelectGoal'));
      return;
    }

    if (customSelected && !customGoal.trim()) {
      alert(t('pleaseEnterCustomGoal'));
      return;
    }

    setIsSubmitting(true);

    setPersonalDetails({
      ...personalDetails,
      goals
    });

    setTimeout(() => {
      setIsSubmitting(false);
      navigate('/language-selection');
    }, 500);
  };

  return (
    <ResponsiveContainer>
      <div className="min-h-[calc(100vh-100px)] bg-gray-100 flex flex-col items-center justify-center p-4">
        <div className="bg-white rounded-lg shadow-lg p-8 max-w-md w-full">
          <h2 className="text-2xl font-semibold text-center mb-6">{t('selectGoals')}</h2>

          <p className="text-gray-600 mb-6 text-center">
            {t('pleaseSelectGoals')}
          </p>

          <form onSubmit={handleSubmit}>
            <div className="space-y-3 mb-6">
              {PREDEFINED_GOALS.map((goal) => (
                <label
                  key={goal}
                  className={`flex items-center p-3 rounded-lg border cursor-pointer transition-colors duration-200 ${
                    selectedGoals.includes(goal)
                      ? 'border-[#d0a949] bg-[#d0a949]/10'
                      : 'border-gray-300 hover:bg-gray-50'
                  }`}
                >
                  <input
                    type="checkbox"
                    checked={selectedGoals.includes(goal)}
                    onChange={() => toggleGoal(goal)}
                    className="h-4 w-4 text-[#d0a949] border-gray-300 rounded focus:ring-[#d0a949]"
                  />
                  <span className="ml-3 text-gray-800">{t(goal)}</span>
                </label>
              ))}

              <label
                className={`flex items-center p-3 rounded-lg border cursor-pointer transition-colors duration-200 ${
                  customSelected
                    ? 'border-[#d0a949] bg-[#d0a949]/10'
                    : 'border-gray-300 hover:bg-gray-50'
                }`}
              >
                <input
                  type="checkbox"
                  checked={customSelected}
                  onChange={() => setCustomSelected((prev) => !prev)}
                  className="h-4 w-4 text-[#d0a949] border-gray-300 rounded focus:ring-[#d0a949]"
                />
                <span className="ml-3 text-gray-800">{t('Other')}</span>
              </label>

              {customSelected && (
                <input
                  type="text"
                  value={customGoal}
                  onChange={(e) => setCustomGoal(e.target.value)}
                  placeholder={t('enterCustomGoal')}
                  className="w-full p-2 border border-gray-300 rounded-md focus:ring-[#d0a949] focus:border-[#d0a949]"
                />
              )}
            </div>

            <div className="flex justify-center">
              <button
                type="submit"
                disabled={isSubmitting}
                className="bg-[#d0a949] hover:bg-[#a6873a] text-white py-3 px-6 rounded-lg shadow transition duration-200 flex items-center justify-center disabled:opacity-50"
              >
                {isSubmitting ? (
                  <span className="inline-block animate-spin mr-2">⏳</span>
                ) : null}
                {t('next')}
              </button>
            </div>
          </form>

          <div className="mt-6 text-center">
            <button
              onClick={() => navigate('/persona-selection')}
              className="text-gray-500 hover:text-gray-700 text-sm"
            >
              {t('back')}
            </button>
          </div>
        </div>
      </div>
    </ResponsiveContainer>
  );
}

export default GoalSelectionPage;
